import { CircularProgress, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { ariaLabel } from "../../constants";

interface Props {
  className?: string;
}

const StyledLoaderContainer = styled("div")`
  padding: ${rem(100)};
  display: flex;
  justify-content: center;
`;

export const Loader = ({ className }: Props) => {
  return (
    <StyledLoaderContainer className={className}>
      <CircularProgress
        data-cy="circular-progress"
        aria-busy
        aria-label={ariaLabel.circularProgressLabel}
      />
    </StyledLoaderContainer>
  );
};
